import { defineMessages, useIntl } from 'react-intl';

import { title as siteTitle } from '@/mastodon/initial_state';
import { Button } from 'mastodon/components/button';
import {
  ModalShell,
  ModalShellActions,
  ModalShellBody,
} from 'mastodon/components/modal_shell';

import type { BaseConfirmationModalProps } from './confirmation_modal';

const messages = defineMessages({
  title: {
    id: 'confirmations.bridged_reply_blocked.title',
    defaultMessage: "Can't reply to a mirrored account",
  },
  message: {
    id: 'confirmations.bridged_reply_blocked.message',
    defaultMessage:
      'This account is a bridge between {siteTitle} and X/Twitter. You cannot reply to it through {siteTitle} — it is just a mirrored account. Use the quote feature instead.',
  },
  ok: {
    id: 'confirmations.bridged_reply_blocked.ok',
    defaultMessage: 'Got it',
  },
});

// A pure notice, not a confirm/cancel choice -- there is nothing to confirm,
// so this skips ConfirmationModal (which always renders a cancel button
// alongside confirm) in favor of a single "Got it" button.
export const BridgedReplyBlockedModal: React.FC<BaseConfirmationModalProps> = ({
  onClose,
}) => {
  const intl = useIntl();

  return (
    <ModalShell>
      <ModalShellBody>
        <h1>{intl.formatMessage(messages.title)}</h1>
        <p>{intl.formatMessage(messages.message, { siteTitle })}</p>
      </ModalShellBody>

      <ModalShellActions>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus -- we are in a modal and thus autofocusing is justified */}
        <Button onClick={onClose} autoFocus>
          {intl.formatMessage(messages.ok)}
        </Button>
      </ModalShellActions>
    </ModalShell>
  );
};
